import { TRPCClientError } from "@trpc/client";

const MAX_QUERY_RETRIES = 3;

// Codes the API returns when a record belongs to another business unit, was
// removed, or the viewer can no longer see it. NOT_FOUND is the API's
// anti-leakage default for records outside the caller's scope.
const RECORD_UNAVAILABLE_CODES = new Set([
  "NOT_FOUND",
  "FORBIDDEN",
  "UNAUTHORIZED",
]);

export function isRecordUnavailableError(error: unknown): boolean {
  if (!(error instanceof TRPCClientError)) {
    return false;
  }
  const code: unknown = error.data?.code;
  return typeof code === "string" && RECORD_UNAVAILABLE_CODES.has(code);
}

// Retrying won't make a record from another business unit appear, so show the
// message right away instead of after React Query's default retries.
export function retryUnlessRecordUnavailable(
  failureCount: number,
  error: unknown,
): boolean {
  return !isRecordUnavailableError(error) && failureCount < MAX_QUERY_RETRIES;
}
